<template>
  <div class="front-container front-home">
    <section class="d-flex justify-content-center align-items-center flex-wrap">
      <div
        class="d-flex align-items-center wow animate__animated animate__fadeInRight"
        data-wow-delay=".5s"
      >
        ME&CODING
      </div>
      <div id="scrollxs" class="scroll-down" v-anchor="'section2'"></div>
    </section>
    <section
      id="section2"
      class="d-flex justify-content-between align-items-center flex-wrap"
    >
      <div class="d-flex flex-column justify-content-center align-items-center">
        <h2>關於ME&CODING</h2>
        <p class="font-weight-normal">
          ME&CODING，一直秉持著結合創意、設計與技術的概念，不斷的成長與茁壯，也繳出了極佳的成績單，我們提供最棒的設計概念導入的網站開發、App開發、品牌與設計，讓您的產品與服務，產生最美好的價值。
        </p>
      </div>
      <div class="d-flex flex-column justify-content-center align-items-center">
        <h2>服務項目</h2>
        <p class="font-weight-normal">
          解決客戶的需求問題視為重要使命
          ，我們仔細的去了解每一個客戶的需求，並提供最適
          合的解決方案。比起只是注重美觀的設計，我們更想
          創造的是一套完整的設計服務體驗。從使用者的角度
          進行規劃與設計，搭配專業分工的團隊合作，提供您 最完美的作品與服務。
        </p>
      </div>
    </section>
    <section
      class="d-flex justify-content-between align-items-center flex-wrap"
    >
      <div
        class="d-flex flex-column justify-content-center align-items-center"
        data-wow-delay=".25s"
      >
        <h2>服務類型</h2>
        <ul>
          <li
            class="wow animate__animated animate__fadeInRight font-weight-normal"
          >
            <p class="font-weight-bold">
              1.WEB SITE
            </p>
            網站與平台開發設計，從形象網站、電子商務、大型平台，我們擁有最佳的設計與開發能力。
          </li>
          <li
            class="wow animate__animated animate__fadeInRight font-weight-normal"
            data-wow-delay=".5s"
          >
            <p class="font-weight-bold">
              2.APP DEVELOPMENT
            </p>
            結合強大功能與技術並擁有最佳的使 用者介面，創造美好的產品體驗。
          </li>
          <li
            class="wow animate__animated animate__fadeInRight font-weight-normal"
            data-wow-delay=".75s"
          >
            <p class="font-weight-bold">3.BRANDING</p>
            透過資料調查與分析，建構最佳品牌概念，打造最適合您的產品品牌。
          </li>
          <li
            class="wow animate__animated animate__fadeInRight font-weight-normal"
            data-wow-delay="1s"
          >
            <p class="font-weight-bold">4.GRAPHIC</p>
            我們擁有最佳的設計師團隊與經驗，
            可以提供最適合您每次需求的平面設計物。
          </li>
        </ul>
      </div>
      <div
        class="wow animate__animated animate__fadeInRight"
        data-wow-delay="1.25s"
      >
        <ul>
          <li>
            <img
              src="../../../../public/images/front/work/handmade.png"
              alt=""
            />
          </li>
          <li>
            <img src="../../../../public/images/front/work/bake.png" alt="" />
          </li>
        </ul>
        <router-link
          :to="{ name: 'work' }"
          class="bgc justify-content-center align-items-center"
        >
          more...
        </router-link>
      </div>
    </section>
    <div class="fixed-title"><span>首頁</span></div>
  </div>
</template>

<script>
export default {
  created() {},
  mounted() {
    this.$nextTick(() => {
      document.getElementById('check').checked = false;
    });
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss"></style>
